module.exports = __webpack_public_path__ + "img/taipingyang.e459694b.png";